import React, { useEffect, useRef, useState } from "react";
import "./view-question.styles.scss";
import { GlobalState } from "../../../../redux/root-reducer";
import { connect } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { fetchApi } from "../../../../redux/fetch/fetch.actions";
import { Dispatch } from "redux";
import { Question } from "../../../../@types/question.interface";
import Loading from "../../../../components/loading/loading.component";
import ViewQuestion from "../../../../components/view-question/view-question.component";
import QuestionActionAPI, {
    IFetchQuestionsPayload,
} from "../../../../redux/question/question.actions";
import "../quiz-page.styles.scss";
import { Answer } from "../../../../@types/answer.interface";

interface IProps {
    isFetching?: boolean;
    errors?: string | null;
    quizId: number;
    userEmail: string;
    questions: Question[] | null;
    fetchQuestions: (id: number) => void;
    clearQuestions: () => void;
    setActiveTab: (tab: number) => void;
}

function ViewQuestionsContainer({
    isFetching,
    errors,
    quizId,
    userEmail,
    questions,
    fetchQuestions,
    clearQuestions,
    setActiveTab,
}: IProps) {
    const match = useRouteMatch<{ id: string }>();
    const id = parseInt(match.params.id);
    const [index, setIndex] = useState(0);
    const g = useRef(0);
    const [question, setQuestion] = useState<Question | null>(null);
    const [answers] = useState<Answer[]>([]);

    useEffect(() => {
        if (isFetching || errors) return;
        if (questions === null) fetchQuestions(id);
    }, [isFetching, errors, fetchQuestions, id, questions]);

    useEffect(() => {
        if (questions) {
            setIndex(0);
            if (questions.length !== 0) setQuestion(questions[0]);
            questions.forEach((question) => {
                answers.push({
                    quiz_id: id,
                    question_id:
                        question.question_id !== undefined
                            ? question.question_id
                            : 0,
                    email_address: "",
                    student_answer: [{ answer: "-" }],
                });
            });
        }
    }, [questions, answers, id]);

    useEffect(() => {
        if (questions && questions?.length !== 0) setQuestion(questions[index]);
    }, [questions, id, index, quizId]);

    const handleClick = (evt: any, name: string, idx?: number) => {
        evt.preventDefault();
        if (questions !== null) {
            g.current = index;
            if (name === "next") {
                if (index + 1 > questions?.length) setIndex(questions.length);
                else {
                    setIndex(g.current + 1);
                    g.current += 1;
                }
            } else if (name === "prev") {
                if (index - 1 < 0) setIndex(0);
                else {
                    setIndex(g.current - 1);
                    g.current -= 1;
                }
            } else if (name === "change") {
                if (idx != null) setIndex(idx);
                g.current = index;
            }
        }
    };

    return (
        <div className="container">
            {isFetching ? (
                <Loading className="relative" />
            ) : (
                <>
                    {questions !== null ? (
                        <div className="view-question">
                            <div className="view-question__index">
                                <span className="view-question__index-label">
                                    Question No.
                                </span>
                                <span className="view-question__index-no">
                                    {index + 1}
                                </span>
                            </div>
                            <ViewQuestion
                                quizId={id}
                                question={question}
                                index={index}
                                answers={answers}
                                setIndex={setIndex}
                                questions={questions}
                                length={questions.length}
                                handleClick={handleClick}
                                setActiveTab={setActiveTab}
                            />
                        </div>
                    ) : (
                        ""
                    )}
                </>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    question: { questions },
}: GlobalState) => ({
    isFetching: isFetching.QUESTIONS,
    errors: errors.QUESTIONS,
    questions,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchQuestions: (id: IFetchQuestionsPayload["data"]["id"]) =>
        dispatch(fetchApi({ name: "QUESTIONS", data: { id } })),
    clearQuestions: () => dispatch(QuestionActionAPI.clearQuestions()),
});

const ViewQuestionsPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewQuestionsContainer);

export default ViewQuestionsPage;
